import { UPDATEFILTER, UPDATEFILTERDATA } from '../types/schoolTypes';

export const UpdateFilter = (dispatch, filter) => {
  dispatch({ type: UPDATEFILTER, payload: filter });
};

export const UpdateCountriesAndCitiesOfFilter = (dispatch, filter) => {
  dispatch({ type: UPDATEFILTERDATA, payload: filter });
};
